
import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { filter } from 'rxjs';
import { ContentfulService } from 'src/app/services/contentful.service';

@Component({
    selector: 'app-info-icon',
    imports: [MatTooltipModule],
    templateUrl: './info-icon.component.html',
    styleUrls: ['./info-icon.component.scss']
})
export class InfoIconComponent {
  private contentfulService = inject(ContentfulService);

  readonly iconSet = toSignal(
    this.contentfulService.getIconSetValue().pipe(filter((v): v is Record<string, string> => !!v))
  );
  readonly tooltipPosition = input<TooltipPosition>('above');
  readonly tooltipInfo = input.required<string>();
  readonly tooltipClass = input<string>('');
}
